import { CallbackSaga, createGeneralCall } from '@altermaind/core/requests-status-management';
import { IS_MOCK_ENABLED } from '@/_shared/constants/mock';
import { GenericPost } from '@/_shared/types';
import { GenericApiError } from '@/_shared/types/apiError';
import { getCurrentOrganization } from '@/core/state/selectors';
import { API_ORGANIZATIONS_ORGANIZATIONID_DEPARTMENTS_DEPARTMENTID_ASSIGN_PATH_KEY } from '@/swagger/constants/anagraphics-keys';
import { KEY_POST_ASSIGN_DEPARTMENT } from '../constants/keys';
import { API_POST_ASSIGN_DEPARTMENT } from '../constants/urls';
import { MOCK_RESPONSE_POST_ASSIGN_DEPARTMENT } from '../mocks';

type RequestPostAssignDepartment = GenericPost<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_DEPARTMENTS_DEPARTMENTID_ASSIGN_PATH_KEY
>['request']['body'];

export type CallParamsPostAssignDepartment = RequestPostAssignDepartment & {
  departmentId: string;
  successSaga?: CallbackSaga;
  errorSaga?: CallbackSaga;
};

export type CallResponsePostAssignDepartment = GenericPost<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_DEPARTMENTS_DEPARTMENTID_ASSIGN_PATH_KEY
>['response']['body'];

type CallErrorPostAssignDepartment = GenericApiError;

export const postAssignDepartmentCall = createGeneralCall<
  CallParamsPostAssignDepartment,
  CallResponsePostAssignDepartment,
  CallErrorPostAssignDepartment
>({
  id: KEY_POST_ASSIGN_DEPARTMENT,
  url:
    ({ payload }) =>
    state => {
      const org = getCurrentOrganization(state);
      return API_POST_ASSIGN_DEPARTMENT(org as unknown as string, payload.departmentId);
    },
  method: 'post',
  paramsSelector:
    ({ payload }) =>
    () => ({ employeeIds: payload.employeeIds }),
  successMock: IS_MOCK_ENABLED() ? MOCK_RESPONSE_POST_ASSIGN_DEPARTMENT : undefined,
  responseExtractor: null,
});
